export const CONSENT_STATE_COOKIE_KEY = "cookie-consent-state";
